import {} from "@/api/user.js";
import { getCookie } from "@/utils/cookie";
import { checkModbile, validateEmail } from '@/utils/utils'

import { getAgent, createAgent, updateAgent, defaultData, meallist, purchasecode, aliCallBack } from "@/api/user.js";
import axios from 'axios'
import draggable from 'vuedraggable';
import PriceDialog from './priceDialog.vue';
import { domainName } from '@/utils/domainName'


export default {
    name: 'price',
    components: {
        draggable,
        PriceDialog
    },
    computed: {},
    watch: {},
    data() {
        return {
            problemIndex: 0,
            tabPosition: 'left',
            priceList: [{
                    id: 1,
                    title: '免费用户',
                    price: '0',
                    priceold: '免费试用3天',
                    // btmlist: ['每天30次 AI会话额度', '仅限个人学习使用']
                },
                {
                    id: 2,
                    title: '单月套餐 VIP',
                    price: '9.9',
                    priceold: '原价 ¥29/月',
                    // btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 3,
                    title: '一年套餐 VIP',
                    price: '99',
                    priceold: '原价 ¥348/年',
                    // btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 4,
                    title: '半年套餐 VIP',
                    price: '79',
                    priceold: '原价 ¥174/半年',
                    // btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                }
            ],

            dialogVisible: false,
            mealList: [],
            getindex: 0,
            getitem: [],
            geturl: '',
            access_token: '',
            showDefault: true
        }
    },
    created() {

    },
    mounted() {
        let queryParams = JSON.parse(getCookie('queryParams')) ? JSON.parse(getCookie('queryParams')) : {}
        if (this.$route.query.partner_uuid || this.$route.query.activation_id || queryParams.partner_uuid || queryParams.activation_id) {
            this.showDefault = false
        }
        this.getExceltest()
        this.setInitialHeight();
        window.addEventListener('resize', this.setInitialHeight);
        this.access_token = getCookie("access_token")
            // 支付宝支付成功回调函数
        if (this.$route.query.method && this.$route.query.method == 'alipay.trade.page.pay.return') {
            this.aliPayCallBack()
        }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setInitialHeight);
    },
    methods: {
        setInitialHeight() {
            // console.log(this.$refs.contentArea.style.height,window.innerHeight,111)
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
        },
        handleTabClick(tab, event) {
            console.log(tab.name)
            this.scrollToSection(tab.name);
        },

        handleMouseEnter(tabId) {
            this.hoveredTab = tabId;
            this.activeTab = tabId
                // if (this.activeTab !== tabId) {
                //     this.scrollToSection(tabId);
                // }
            this.goToSlide()
            this.$nextTick(() => this.$forceUpdate());

        },

        goToSlide() {
            // this.currentIndex = 3;
            const carousel = this.$refs.carouselRef;
            console.log(carousel)
            carousel.activeIndex = this.activeTab * 1
        },
        handleMouseLeave() {
            this.hoveredTab = null;
        },
        scrollToSection(sectionId) {
            const sectionElement = document.getElementById(sectionId);
            if (sectionElement) {
                sectionElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },

        handleClose(done) {
            this.$refs.PriceDialog.closePay()
                // this.$confirm('确认关闭？')
                //   .then(_ => {
                //     done();
                //   })
                //   .catch(_ => {});
        },
        // 点击购买
        goBuy(index) {
            if (!getCookie("access_token")) {
                this.$store.commit("setLoginDisplay", true);
            } else {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                this.getindex = index
                this.dialogVisible = true

                setTimeout(() => {
                    if (this.showDefault) {
                        this.$refs.PriceDialog.init(this.getindex - 1)
                    } else {
                        this.$refs.PriceDialog.init(this.getindex)
                    }
                }, 100);
            }

        },

        useBtnPro() {
            if (getCookie("access_token")) {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                location.href = domainName.api9 + '/#/excelPro'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        // 选择购买时长
        clickType(item, index) {
            this.getindex = index
            this.getitem = item
            this.getqrCode()
        },
        // meallist, purchasecode 
        //   套餐列表
        getExceltest() {
            meallist({ meal_type: 'excel', access_token: getCookie("access_token"), }).then((res) => {
                this.mealList = res.data.data
                if (this.showDefault) {
                    this.mealList.unshift({
                        id: 0,
                        meal_name: '免费试用',
                        current_price: '0',
                        priceold: '每天免费用',
                    })
                }

            });
        },
        getqrCode() {
            purchasecode({ meal_type: 'excel', id: this.getitem.id, access_token: getCookie("access_token"), }).then((res) => {
                this.geturl = res.data.data.url
            });
        },
        buyClick() {
            location.href = this.geturl
                // window.open(this.geturl)
        },
        aliPayCallBack() {
            let params = this.$route.query
            params.access_token = getCookie("access_token")
            aliCallBack(params).then((res) => {});
        },

    }
}